<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    offset-y
    min-width="290px"
    v-model="menu"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="getTextfieldDate"
        :label="labelText"
        persistent-hint
        append-icon="event"
        readonly
        v-on="on"
        :dense="dense"
        :clearable="clear"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="dateValue"
      prev-icon="arrow_left"
      next-icon="arrow_right"
      locale="ru"
      first-day-of-week="1"
      no-title
      @input="handlerInput($event)"
      :allowed-dates="allowedDatesFunction"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
import FORMAT from '@/config/format'

export default {
  name: 'DatePicker',
  props: {
    labelText: {
      type: String,
      required: true
    },
    dateValue: {
      type: String || null,
      required: false
    },
    allowedDatesFunction: {
      type: Function,
      default: val => val
    },
    dense: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    }
  },
  computed: {
    getTextfieldDate() {
      {
        if (this.dateValue != null) {
          return moment(this.dateValue).format(FORMAT.datepickerDate)
        }
        return ''
      }
    }
  },
  methods: {
    handlerInput(value) {
      this.$emit(
        'update:dateValue',
        moment(value).format(FORMAT.datepickerDate)
      )
      this.$emit('changeDate', moment(value).format(FORMAT.datepickerDate))
      this.menu = false
    }
  }
}
</script>
